import _ from '../../core/utils'
const sliderAboutConfig = {
    sliders: _.selectAll( '.slider--about' )
}
export default sliderAboutConfig